<template>
  <div class="practice-layout pralay">
    <div class="pralay_center">
      <router-view :key="$route.name"></router-view>
    </div>
  </div>
</template>

<script>
import links_mix from '@/mixins/links_mix'
import screen_mix from '@/mixins/screen_mix'
import float_mix from '@/mixins/float_mix'

export default {
  name: 'Practice',
  mixins: [links_mix, screen_mix, float_mix],
  data() {
    this.tagLiveStyle = `
        --tag-height:1rem;--tag-size:0.8rem;
        --tag-padding:0 0.25rem;--clr-tag:var(--clr-white-0); --clr-tag-back: var(--clr-error);
        `
    return {}
  },
  computed: {
    hasSidebar() {
      return (
        !this.mobile &&
        (this.$route.name === 'PracticeStats' ||
          this.$route.name === 'PracticeSessions' ||
          this.$route.name === 'PracticeDrills' ||
          this.$route.name === 'PracticeHands' ||
          // || (this.$route.name === 'PracticeRangeBuilder' && this.$store.getters.rangebuilder_configure)
          (this.$route.name === 'PracticeTrainer' && this.$store.getters.hands_configure))
      )
    },
  },
}
</script>
<style lang="scss">
@media (max-width: 1023px) {
  .pralay {
    min-height: var(--vh-3);
    min-width: 100vw;
    &_center {
      min-height: var(--vh-3);
      min-width: 100vw;
    }
    &_right {
    }
  }
}
.pralay {
  flex: 1;
  display: flex;
  &_left {
    z-index: 2;
  }
  &_center {
    height: var(--vh-3);
    flex: 1;
    display: flex;
    min-height: 0;
    overflow: hidden;
    z-index: 1;
    // flex-direction: column;
    // overflow-y: auto;
    // overflow-x: hidden;
  }
  // &_left {
  //   width: var(--left-sidebar-width);
  //   padding: 0.5rem 0;
  //   background: var(--clr-black-1);
  //   // margin-right: 0.5rem;
  // }
}
</style>
